function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.17376 19.9316L13.3533 26.088L12.2787 27.1585C12.0299 27.4063 11.6269 27.4057 11.3788 27.1573L6.12425 21.8918C5.87935 21.6462 5.87776 21.25 6.12108 21.0025L7.17376 19.9316Z",
  fill: "#D5D7DE"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.54075 23.2588L9.63172 27.1417L8.79472 28.1417C8.62669 28.3423 8.35224 28.4195 8.10384 28.336L3.43252 26.7664C2.99226 26.6183 2.85504 26.0651 3.17586 25.73L5.54075 23.2588Z",
  fill: "#D5D7DE"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.8338 25.4202C14.2646 25.4493 13.8494 25.1718 13.4638 24.7851C11.7323 23.0471 9.98997 21.3196 8.24959 19.5905C7.26075 18.6082 7.34397 17.687 8.38332 16.7971C13.1423 12.7218 17.8994 8.64459 22.6542 4.56453C23.5001 3.83858 24.3533 3.7851 25.1681 4.56579C26.2986 5.64902 27.4082 6.75535 28.499 7.87845C29.2788 8.6813 29.2673 9.54617 28.5418 10.3889C24.422 15.1737 20.2976 19.9544 16.1777 24.7392C15.8204 25.1544 15.4036 25.4326 14.8338 25.4202Z",
  fill: "#D5D7DE"
});

var SvgMarkerpen = function SvgMarkerpen(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMarkerpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/markerpen.4422f486.svg";
export { ForwardRef as ReactComponent };